<script>
import MakesHttpRequests from './MakesHttpRequests.vue';
import UsesHandlers from './UsesHandlers.vue';
import { parseDom } from 'larasnap';
import { remove, Toast } from 'larasnap/support';

export default {
    mixins: [MakesHttpRequests, UsesHandlers],
    methods: {
        reload({ hidden = false, message = '' } = {}) {
            return this.$http('reload')
                .withLoader(!hidden)
                .send()
                .then(rows => {
                    this.mergeRows(rows);
                    if (message) {
                        Toast.info(message);
                    }

                    this.runHandler('reload-complete');

                    this.$nextTick(parseDom);
                });
        },
        mergeRows(rows) {
            this.data.rows.forEach(row => (row.updated = false));

            rows.forEach(this.mergeRow);

            remove(this.data.rows, { updated: false });
        },
        mergeRow(row) {
            const existingRow = this.data.rows.find(x => x.id === row.id);

            if (existingRow) {
                existingRow.order = row.order;
                existingRow.cells = row.cells;
                existingRow.fields = row.fields;
                existingRow.style = row.style;
                existingRow.updated = true;
            } else {
                this.data.rows.push(row);
            }
        },
    },
};
</script>
